import { UnstyledButton, Flex, Box } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { useAEMNavData } from "@AEM/hooks/useAEMNavData"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import type { AEMSvgData } from "@components/AEMSvg"
import { AEMSvg } from "@components/AEMSvg"
import { AssistanceModal } from "@components/ui/AssistanceModal/AssistanceModal"
import { IconHelpCircle } from "@tabler/icons-react"
import { svgToUrl } from "@utils/svgToUrl"
import minimalStyles from "./MinimalSidebarHelpIcon.module.css"

export function MinimalSidebarHelpIcon() {
	const [opened, { open, close }] = useDisclosure(false)
	const { data: iconLinksComponentData } = useAEMNavData(
		AEMPageType.NAVIGATION_SIDEBAR
	)

	let helpIcon: AEMSvgData | undefined
	const helpNode = iconLinksComponentData?.[1]?.children?.items?.[1]
	if (helpNode && "icon" in helpNode) {
		helpIcon = {
			path: svgToUrl(helpNode.icon),
			title: helpNode.label
		} as AEMSvgData
	}

	return (
		<>
			<Box className={minimalStyles.strip}>
				<Flex className={minimalStyles.stripInner}>
					<UnstyledButton
						onClick={open}
						className={minimalStyles.bottomButton}
						aria-label="Help And Assistance"
					>
						{helpIcon ? (
							<AEMSvg ariaRole="button" svgData={helpIcon} />
						) : (
							<IconHelpCircle size={24} stroke={1.5} />
						)}
					</UnstyledButton>
				</Flex>
			</Box>
			<AssistanceModal opened={opened} onClose={close} />
		</>
	)
}

export default MinimalSidebarHelpIcon
